// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__19_Ju","row":"styles_row__35731"};